export function shouldRenderNewParticipantLink(navigationLink = "") {
  const isNewSite =
    window.location.pathname.includes("nq-participant") ||
    window.location.href.includes("local");
  const isLinkToNewSite = navigationLink.includes("nq-participant");
  const newHost =
    navigationLink.includes("nq.individuals") ||
    navigationLink.includes("local");
  return isNewSite && isLinkToNewSite && newHost;
}
